var map = {
	"./33325742.jpg": 1045,
	"./Benefits_of_E_invoicing.jpg": 5689,
	"./ClodareForEinv.png": 7159,
	"./CloudareForEinvCard.jpg": 9416,
	"./Comply.webp": 5144,
	"./Cosmo.png": 101,
	"./Cosmo1.jpg": 7356,
	"./Cosmo2.jpg": 2011,
	"./Cosmo3.jpg": 3966,
	"./Cosmo4.jpg": 3237,
	"./Cosmo5.png": 5724,
	"./Cosmo6.png": 7479,
	"./Cosmo7.png": 8254,
	"./CosmoExpo.png": 4017,
	"./EBS.png": 2916,
	"./EINV PROCESS.png": 1895,
	"./ERP1.jpg": 6066,
	"./Einv.jpg": 8344,
	"./FTAlogo.webp": 9738,
	"./FeaturedInStartups.png": 5075,
	"./Futops.png": 1925,
	"./G4.png": 3111,
	"./G5.png": 7326,
	"./G6.png": 4053,
	"./GATE Summit1.jpeg": 3210,
	"./GATE Summit2.jpeg": 7847,
	"./GATE Summit3.jpeg": 4624,
	"./GATE Summit7.jpeg": 8244,
	"./GATE Summit8.jpeg": 7417,
	"./GATE.png": 467,
	"./GateSummit.png": 438,
	"./GotAProject.jpg": 6994,
	"./Grandee.png": 2552,
	"./Group 117.webp": 2988,
	"./HR-Consulting.png": 3483,
	"./HackerRank.webp": 7076,
	"./NBFC Summit DarkBG.png": 8557,
	"./NetSuite.webp": 305,
	"./NetSuitee.jpg": 6708,
	"./OdooTop.png": 8524,
	"./Oracle EBS FUSION.png": 8166,
	"./OracleNetsuite.png": 5343,
	"./Rectangle 58.png": 9512,
	"./Suguna.png": 6277,
	"./Tech Summit.png": 6589,
	"./TechSummit1.png": 7986,
	"./TechSummit2.png": 1993,
	"./TechSummit3.png": 9888,
	"./TechSummit4.png": 2111,
	"./Vector-1.png": 5017,
	"./Vector-2.png": 8434,
	"./Vector-3.png": 8939,
	"./Vector-4.png": 9028,
	"./Vector-5.png": 157,
	"./Vector-6.png": 2598,
	"./Vector-7.png": 4143,
	"./Vector-8.png": 9336,
	"./analytics.jpeg": 3889,
	"./analytics.webp": 9872,
	"./applyjob.webp": 6215,
	"./awardCertificate.png": 1826,
	"./awardHall.png": 7318,
	"./awardHero.png": 2599,
	"./bgr.svg": 2101,
	"./bigbasket.jpg": 8548,
	"./caratlane.jpg": 3531,
	"./chattisgarh_startup.png": 2506,
	"./clearTax.webp": 7238,
	"./cloud.jpeg": 6656,
	"./cloud.webp": 1173,
	"./cloudare.webp": 7197,
	"./consult-landing.webp": 4570,
	"./convoro_new.png": 6731,
	"./curefoods.png": 4674,
	"./cygnet.jpg": 3046,
	"./desktop.ini": 3784,
	"./favIcon.png": 9376,
	"./fusion.png": 182,
	"./gst.jpg": 4874,
	"./hire-talent.webp": 4379,
	"./hungerbox.svg": 3864,
	"./impact.jpg": 9168,
	"./implementation.jpg": 3112,
	"./implementation.webp": 8302,
	"./integra.svg": 4900,
	"./jaggaer.webp": 8037,
	"./lhdn.png": 1672,
	"./marosa.png": 9293,
	"./mensa.png": 392,
	"./mensa.webp": 6568,
	"./modularandaffordable.png": 7398,
	"./msme.png": 4656,
	"./newLogo.png": 227,
	"./oddo Partner.png": 9426,
	"./oracle-partner-logo.png": 5741,
	"./oscar.jpg": 6760,
	"./peppol.png": 1466,
	"./peppol1.png": 3705,
	"./project-scope.webp": 9844,
	"./project.webp": 7593,
	"./projectScope.jpg": 1563,
	"./sailesh.jpg": 4305,
	"./shar.png": 1934,
	"./srg.png": 9318,
	"./support.png": 6805,
	"./support.webp": 2151,
	"./tick1.png": 8508,
	"./usa-first.png": 6352,
	"./virtusa.png": 1422,
	"./what-is-hr.webp": 7618,
	"./work.png": 2469,
	"./zatca.webp": 6547,
	"./zoho-partner-logo-1.webp": 3621,
	"./zoho-partner-logo-2.png": 8692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9420;